import { PageCondensed } from '@/layouts'

import { useRouteOrg } from '../../orgRoute'
import { ProductFlagsForm } from './components/ProductFlagsForm'

/**
 * An organization's product flags.
 *
 * The form is keyed on the organization so moving to another one rebuilds it from
 * that organization's stored flags, rather than syncing new values into form state
 * that is already holding somebody else's.
 *
 * The wrapper is bounded to the pane because the form scrolls its product flag list on
 * its own — letting the tab grow instead would put a second scrollbar around the first.
 */
export const ProductFlagsTab = () => {
  const org = useRouteOrg()

  return (
    <PageCondensed fullHeight>
      <ProductFlagsForm key={org.id} org={org} />
    </PageCondensed>
  )
}
